<div
  #topElement
  id="cac-prequalfinal-success-div-backGround"
  class="col-md-12 divBorder"
>
  <div id="cac-prequalfinal-success-div-right" class="">
    <div class="divWhiteBackground">
      <div class="wizard logoalignment">
        <div
          role="presentation"
          class="slider-icon-disabled custom-display-inline"
        >
          <div class="left-slot">
            <a href="/" aria-label="Credit Acceptance home">
              <img
                src="{{ logoURL }}"
                alt="Credit Acceptance"
                width="150"
                height="35px"
              />
            </a>
          </div>
        </div>
        <div
          class="slot custom-display-inline closeBtn-finalResponse"
          (click)="navigateToHome()"
        >
          <img
            alt="close icon"
            class="lightgrey cursorpointer closeImgSize"
            src="{{ closeURL }}"
            alt=""
          />
        </div>
      </div>

      <div id="cac-prequalfinal-success-message" class="form-group center">
        <ng-container *ngIf="!inventoryExperienceActive">
          <h2 class="congrats h3-black" id="cacfinal-success-congrats-h2">
            {{ formFieldData?.title }}
          </h2>
          <br class="mobileOnly" />
          <h5 class="infotext-finalResponse h4-black">
            {{ formFieldData?.prequalifiedSubTitle }}
          </h5>
        </ng-container>
        <!--
          Inventory experience: unified orange header. The title and the first
          sentence share the first line ("Congratulations! Your info has been
          submitted."); the second sentence is forced onto its own line.
        -->
        <h2
          *ngIf="inventoryExperienceActive"
          class="congrats h4-black"
          id="cacfinal-success-congrats-h2"
        >
          {{ formFieldData?.title }}
          {{ formFieldData?.prequalifiedSubTitleInventory }}<br />{{
            formFieldData?.prequalifiedSubTitleInventoryNext
          }}
        </h2>
      </div>
      <div>
        <div *ngIf="!inventoryExperienceActive" class="imgspacing">
          <img src="{{ congratsImg }}" alt="" width="100%" />
        </div>
        <div class="form-group center mt-12px">
          <div
            *ngIf="!inventoryExperienceActive"
            class="congrats h4-black bold center"
          >
            {{ formFieldData.prequalifiedContact }}<br />{{
              formFieldData.prequalifiedNext24
            }}
          </div>
          <div *ngIf="inventoryExperienceActive" class="h4-black center">
            {{ formFieldData.prequalifiedContactInventory }}
          </div>
        </div>
        <div class="dealer-info-container wizard desktop">
          <div *ngFor="let dealer of dealers; let i = index">
            <div id="dealer{{ i }}" class="dealer-info-item">
              <div class="custom-display-inline dealer-info-align">
                <p class="form-field-black dealer-name">
                  {{ dealer?.dealerName }}
                </p>
                <p class="form-field-black">
                  {{ dealer?.addressLine1 | titlecase }}
                </p>
                <p class="form-field-black">
                  {{ dealer?.city | titlecase }}, {{ dealer?.state }}
                  {{ dealer?.zip }}
                </p>
                <p class="form-field-black">
                  <a
                    href="tel:{{ dealer?.phone ?? '' | phoneFormat }}"
                    class="phone-number"
                    *ngIf="dealer?.phone"
                    >{{
                      (dealer?.phone ?? '' | phoneFormat).replaceAll('-', '.')
                    }}</a
                  >
                  <span *ngIf="dealer?.phone && dealer?.website"> | </span>
                  <a
                    href="{{ dealer?.website }}"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="phone-number"
                    *ngIf="dealer?.website"
                    >Website</a
                  >
                </p>
                <p
                  class="form-field-black inventory-link-container"
                  *ngIf="dealer.inventoryUrl"
                >
                  <a
                    [href]="dealer.inventoryUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="inventory-link"
                    (click)="onInventoryLinkClick(dealer)"
                    >View dealer's inventory
                    <i
                      class="fas fa-external-link-alt inventory-link-icon"
                      aria-hidden="true"
                    ></i>
                  </a>
                </p>
              </div>
              <div
                *ngIf="i !== 2"
                class="custom-display-inline dealer-info-vertical"
              >
                <hr class="dealer-info-hr-vertical" />
              </div>
            </div>
          </div>
        </div>
        <ng-container>
          <div
            *ngFor="let dealer of dealers; let i = index"
            class="formStyle mobileOnly wizard"
          >
            <div id="mobiledealer{{ i }}">
              <div class="blackColor-80">
                <p class="form-field-black dealer-name">
                  {{ dealer?.dealerName }}
                </p>
                <p class="form-field-black">
                  {{ dealer?.addressLine1 | titlecase }}
                </p>
                <p class="form-field-black">
                  {{ dealer?.city | titlecase }}, {{ dealer?.state }}
                  {{ dealer?.zip }}
                </p>
                <p class="form-field-black">
                  <a
                    href="tel:{{ dealer?.phone ?? '' | phoneFormat }}"
                    class="phone-number"
                    *ngIf="dealer?.phone"
                    >{{
                      (dealer?.phone ?? '' | phoneFormat).replaceAll('-', '.')
                    }}</a
                  >
                  <span *ngIf="dealer?.phone && dealer?.website"> | </span>
                  <a
                    href="{{ dealer?.website }}"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="phone-number"
                    *ngIf="dealer?.website"
                    >Website</a
                  >
                </p>
                <p
                  class="form-field-black inventory-link-container"
                  *ngIf="dealer.inventoryUrl"
                >
                  <a
                    [href]="dealer.inventoryUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="inventory-link"
                    (click)="onInventoryLinkClick(dealer)"
                    >View dealer's inventory
                    <i
                      class="fas fa-external-link-alt inventory-link-icon"
                      aria-hidden="true"
                    ></i>
                  </a>
                </p>
              </div>

              <hr class="dealer-info-hr-horizontal" />
            </div>
          </div>
        </ng-container>
      </div>
      <div
        *ngIf="showInventoryModule && inventoryDisplayState === 'available'"
        class="inventory-intro center"
      >
        <h4 class="congrats h4-black bold">
          {{ formFieldData?.inventoryIntroTitle }}
        </h4>
      </div>
      <div
        *ngIf="showInventoryModule"
        [id]="embedTargetId"
        class="inventory-module-embed"
      ></div>
    </div>
  </div>
  <div class="dealer-finder-options">
    <h4 class="dealer-finder-options-title h3-black">
      Looking for more dealer options?
    </h4>
    <div class="h4-black dealer-finder-options-info">
      We've sent your information to the dealers above, but if you need more
      options, it's easy to find participating dealers near you.
    </div>
    <div class="dealer-finder-options-button-container">
      <a
        [href]="getDealerFinderUrlWithUserLocation()"
        class="btn btn-primary btn-default"
        >Find Dealers</a
      >
    </div>
  </div>
</div>
